import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { MobileTabBar } from './MobileTabBar';
import { useAuthStore } from '@store/auth';
import { useMe } from '@features/auth';
import { KvkkOnayModal } from '@features/auth';
import { LisansPasifBandi } from '@features/lisans';
import { CommandPalette } from '@components/CommandPalette';
import { ZoMaskot } from '@components/ZoMaskot';
import { useCommandPalette } from '@/hooks/useCommandPalette';

export function AppLayout() {
  // /auth/me'yi sub-tree mount olunca aktive et (useMe hem cache hem fetch)
  useMe();
  const me = useAuthStore((s) => s.me);
  const showKvkkModal = !!me && me.kvkkAcikRiza === false;

  // Mobil off-canvas sidebar açık/kapalı durumu.
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { open: cmdOpen, setOpen: setCmdOpen } = useCommandPalette();
  // Zo asistanından gelen hazır arama metni (palet açılışında kullanılır).
  const [zoQuery, setZoQuery] = useState<string | undefined>(undefined);

  // Route değişince mobil menüyü otomatik kapat.
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <Sidebar
        mobileOpen={mobileMenuOpen}
        onMobileClose={() => setMobileMenuOpen(false)}
      />
      <div className="flex flex-1 flex-col overflow-hidden">
        {/* Lisans pasif: üstte sabit bant + 403 bildirimi (normal modda boş) */}
        <LisansPasifBandi />
        <Header
          onMobileMenuClick={() => setMobileMenuOpen(true)}
          onSearchOpen={() => {
            setZoQuery(undefined);
            setCmdOpen(true);
          }}
        />
        <main className="flex-1 overflow-y-auto p-4 pb-20 md:p-6 md:pb-6">
          <Outlet />
        </main>
      </div>
      <MobileTabBar onMenuClick={() => setMobileMenuOpen(true)} />
      <ZoMaskot
        onSearch={(q) => {
          setZoQuery(q);
          setCmdOpen(true);
        }}
      />
      {showKvkkModal && <KvkkOnayModal />}
      <CommandPalette
        open={cmdOpen}
        onClose={() => setCmdOpen(false)}
        initialQuery={zoQuery}
      />
    </div>
  );
}
